
import { logger } from "@/lib/logger";
import { WebsiteAnalysisResult } from "../types";

/**
 * Validate that analysis results have meaningful data
 */
export function hasValidAnalysisData(result: WebsiteAnalysisResult): boolean {
  // Check if we have at least some meaningful data
  const hasBasicInfo = !!result.businessName || !!result.industry;
  const hasContent = !!result.description && 
                    !result.description.includes("Unable to analyze website");
  const hasMetadata = (result.keywords && result.keywords.length > 0) || 
                      (result.colors && result.colors.length > 0) || 
                      !!result.targetAudience || 
                      !!result.brandVoice || 
                      !!result.tone;
                      
  // Log what we found to help with debugging
  logger.info({
    message: "Validating analysis results",
    context: {
      hasBasicInfo,
      hasContent,
      hasMetadata,
      resultKeys: Object.keys(result),
      // Add more details for debugging
      business: result.businessName || "missing",
      industry: result.industry || "missing",
      keywordsCount: result.keywords?.length || 0,
      colorsCount: result.colors?.length || 0,
      descriptionLength: result.description?.length || 0
    }
  });
  
  return Boolean(hasBasicInfo || hasContent || hasMetadata);
}
